<template>
    <div>
        <div class="page-container">
            <v-page-header
                title="批量修改新员工"
                :back="{
                    title: '组织架构',
                    goBack,
                }"
            />
            <div v-show="showResult">
                <div v-if="failPeople === 0" class="page_result_success"></div>
                <div v-if="successPeople > 0 && failPeople > 0" class="page_result_problem"></div>
                <div v-if="successPeople === 0 && noChangeNum === 0" class="page_result_fail"></div>
                <div v-if="failPeople === 0" class="page_text">
                    修改成功<span>{{ successPeople }}</span
                    >人, 无变化{{ noChangePeople }}人
                </div>
                <div v-if="failPeople > 0" class="page_text">
                    修改成功<span class="export_success">{{ successPeople }}</span
                    >人,无变化{{ noChangePeople }}人,失败<span class="export_fail">{{ failPeople }}</span
                    >人
                </div>
                <!-- <div v-if="successPeople === 0 && failPeople === 0" class="page_text">
                    <span>导入员工超过可导入员工数</span>
                </div> -->
                <div v-if="failPeople > 0" class="export_middle_text">
                    <span>{{ failMsg }}</span>
                </div>

                <!-- <div v-if="successPeople === 0">
                    可能导致导入失败的原因：1、必填字段缺失；2、账号名重复；3、填写内容不规范；4、手机号重复
                </div>
                <div v-if="importfail">
                    可能导致导入失败的原因：填写内容不规范
                </div>
                <div v-if="importfail">
                    请减少要导入的员工数：需要更多账号，请联系经销商（上海国经 400-783-092）购买
                </div>-->

                <div class="page_botton">
                    <v-button v-if="failPeople === 0" status="primary" size="large" @click="successBtn">完成</v-button>
                    <v-button
                        v-if="failPeople > 0"
                        class="botton_left"
                        status="primary"
                        size="large"
                        @click="downFailList"
                        >下载失败列表</v-button
                    >
                    <v-button
                        v-if="successPeople > 0"
                        class="botton_left"
                        status="default"
                        size="large"
                        @click="goToExportPage"
                        >继续修改新员工</v-button
                    >
                    <v-button
                        v-if="successPeople === 0 && failPeople === 0"
                        class="botton_left"
                        status="primary"
                        size="large"
                        @click="goToUploadPage"
                        >重新上传文件</v-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable prefer-destructuring */

import { Icon } from 'vhtml-ui';
import { envDomain } from '@/utils/domainConfig';

const req = require.context('@/assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);
export default {
    data() {
        return {
            successPeople: 0,
            failPeople: 0,
            noChangePeople: 0,
            failMsg: '可能导致修改失败的原因：1、必填字段缺失；2、账号名重复；3、填写内容不规范；4、手机号重复',
            checkStatusUrl: envDomain.gateway + '/v1/mng/org/importExportCheckStatus?taskType=1',
            showResult: false,
            downloadErrorListUrl: ''
        };
    },
    computed: {},
    mounted() {
        this.getExportStatus();
    },
    methods: {
        goBack() {
            window.location.href = '/mng/org';
        },
        getExportStatus() {
            const that = this;
            this.importExportCheckStatus()
                .then(data => {
                    this.downloadErrorListUrl = data.data.result_file_url;
                    that.successPeople = data.data.successNum;
                    that.failPeople = data.data.failedNum;
                    that.noChangePeople = data.data.noChangeNum;
                    that.failMsg = data.message;
                    that.showResult = true;
                })
                .catch(err => {
                    this.$message.error(err.message);
                });
        },
        importExportCheckStatus() {
            return new Promise((resolve, reject) => {
                this.$ajax
                    .crossGet(this.checkStatusUrl)
                    .then(data => {
                        if (data && data.code === 0) {
                            resolve(data);
                        } else {
                            reject(new Error(data.msg));
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        successBtn() {
            window.location.href = '/mng/org';
        },
        downFailList() {
            window.open(this.downloadErrorListUrl);
        },
        goToExportPage() {
            window.location.href = '/mng/org/importMembersChange';
        },
        goToUploadPage() {
            window.location.href = '/mng/org/importMembersChange';
        }
    }
};
</script>

<style lang="less">
@import '../styles/app';
</style>
